import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { del, get, post, put, putPresigned, save } from "../../services/API/ApiClient";
import { RootState } from "../Store";
import { DocumentPropertyType, defaultRequestBodyType } from "../../constant/document";

import { CancelTokenSource } from "axios";
import { UploadFile, message } from "antd";
import { RcFile } from "antd/es/upload";
import { DocumentUploadArgs, DocumentUpdateArgs } from "../../constant/document";
import { openNotification } from "../../components/Template/NotificationComponent";
import { FontIcon } from "@fluentui/react";
import React from "react";

// export const data = {};

export const fetchDocuments = createAsyncThunk<any, { view: string | null; documentId?: number }, { state: RootState }>("engageTranslation/fetchDocuments", async (args, { getState, dispatch, rejectWithValue }) => {
  let reqBody;
  let reqUrl;

  switch (args.view) {
    case "new":
      reqBody = {
        ...getState().engageTranslationState.newTabState.currentRequestBody,
        viewName: "new",
      };
      reqUrl = "/production/documents/search";
      break;
    case "quality-control":
      reqBody = {
        ...getState().engageTranslationState.qualityControlState.currentRequestBody,
        viewName: "quality-control",
      };
      reqUrl = "/production/documents/search";
      break;
    case "client-ready":
      reqBody = {
        ...getState().engageTranslationState.clientReadyState.currentRequestBody,
        viewName: "client-ready",
      };
      reqUrl = "/production/documents/search";
      break;
    case "archived":
      reqBody = {
        ...getState().engageTranslationState.archivedTabState.currentRequestBody,
        viewName: "archived",
      };
      reqUrl = "/production/documents/search";
      break;
    case "all":
      reqBody = {
        ...getState().engageTranslationState.allTabState.currentRequestBody,
        viewName: "all",
      };
      reqUrl = "/production/documents/search";
      break;
    case "audit-log":
      reqBody = {
        ...getState().engageTranslationState.auditLogPageState.currentRequestBody,
        DocumentId: args.documentId,
      };
      reqUrl = "/common/documents/audit-entries";
      break;
    default:
      reqBody = {
        ...getState().engageTranslationState.newTabState.currentRequestBody,
        viewName: "new",
      };
      reqUrl = "/production/documents/search";
      break;
  }
  try {
    const response = await post(reqUrl, "engage-translate", reqBody);

    if (!reqUrl.includes("audit")) {
      const tabViews = response.data.tabViews.map((tabView: any) => {
        return {
          label: tabView.name,
          key: tabView.internalName,
          count: tabView.count,
        };
      });
      return { ...response.data, view: args.view, tabViews: tabViews };
    } else {
      return {
        data: response.data.results,
        searchHeading: response.data.searchResultHeading,
      };
    }
  } catch (err: any) {
    console.log("fetching documents error: ", err);
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});

export const fetchPaginateDocuments = createAsyncThunk<any, { view: string; documentId?: number }, { state: RootState }>("engageTranslation/fetchPaginateDocuments", async (args, { getState, dispatch }) => {
  let reqBody;
  let reqUrl;
  switch (args.view) {
    case "new":
      reqBody = {
        ...getState().engageTranslationState.newTabState.currentRequestBody,
        viewName: "new",
        pageNum: getState().engageTranslationState.newTabState.pagination.page,
      };
      reqUrl = "/production/documents/search";
      break;
    case "quality-control":
      reqBody = {
        ...getState().engageTranslationState.qualityControlState.currentRequestBody,
        viewName: "quality-control",
        pageNum: getState().engageTranslationState.qualityControlState.pagination.page,
      };
      reqUrl = "/production/documents/search";

      break;
    case "client-ready":
      reqBody = {
        ...getState().engageTranslationState.clientReadyState.currentRequestBody,
        viewName: "client-ready",
        pageNum: getState().engageTranslationState.clientReadyState.pagination.page,
      };
      reqUrl = "/production/documents/search";

      break;
    case "archived":
      reqBody = {
        ...getState().engageTranslationState.archivedTabState.currentRequestBody,
        viewName: "archived",
        pageNum: getState().engageTranslationState.archivedTabState.pagination.page,
      };
      reqUrl = "/production/documents/search";
      break;
    case "all":
      reqBody = {
        ...getState().engageTranslationState.allTabState.currentRequestBody,
        viewName: "all",
        pageNum: getState().engageTranslationState.allTabState.pagination.page,
      };
      reqUrl = "/production/documents/search";
      break;
    case "audit-log":
      reqBody = {
        ...getState().engageTranslationState.auditLogPageState.currentRequestBody,
        DocumentId: args.documentId,
        pageNum: getState().engageTranslationState.auditLogPageState.pagination.page,
      };
      reqUrl = "/common/documents/audit-entries";
      break;
    default:
      reqBody = {
        ...getState().engageTranslationState.newTabState.currentRequestBody,
        viewName: "new",
        pageNum: getState().engageTranslationState.newTabState.pagination.page,
      };
      reqUrl = "/production/documents/search";
      break;
  }
  try {
    const response = await post(reqUrl, "engage-translate", reqBody);
    return {
      data: response.data.results,
      hasMore: response.data.results.length > 0,
      view: args.view,
    };

    // const response = await post(
    //   "/documents/search",
    //   "engage-translate",
    //   reqBody
    // );
    // return {
    //   data: response.data.results,
    //   hasMore: response.data.results.length > 0,
    //   view: view,
    // };
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});

export const fetchUploadMetaData = createAsyncThunk<any, void, { state: RootState }>("engageTranslation/fetchUploadMetaData", async (args, { getState, dispatch }) => {
  try {
    const response_client_list = await get("/production/clients/pick-list", "engage-translate");
    const response_source_language_list = await get("/common/languages/pick-list", "engage-translate");
    const clientList = response_client_list.data.map((client: any) => ({
      label: client.name,
      value: client.id,
      id: client.id,
    }));
    const sourceLanguageList = response_source_language_list.data.map((language: any) => ({
      label: language.name,
      value: language.id,
      id: language.id,
    }));

    return { clientList: clientList, sourceLanguageList: sourceLanguageList };
  } catch (err: any) {
    console.log("fetching upload meta data error: ", err);
    throw new Error(err.response?.data ?? "Failed to upload meta data");
  }
});

export const fetchTargetLanguageList = createAsyncThunk<any, number, { state: RootState }>("engageTranslation/fetchTargetLanguageList", async (sourceLanguage, { getState, dispatch }) => {
  try {
    const response_target_language_list = await get(`/common/languages/${sourceLanguage}/targets`, "engage-translate");
    const targetLanguageList = response_target_language_list.data.map((language: any) => ({
      label: language.name,
      value: language.id,
      id: language.id,
    }));
    return { targetLanguageList: targetLanguageList };
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to target language");
  }
});
export const quickTextTranslation = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/quickTextTranslation", async (args, { getState, dispatch }) => {
  try {
    const response = await post(`/common/translate/text`, "engage-translate", args);
    return response;
  } catch (err: any) {
    throw new Error(err.response?.data?.message ?? "Failed to translate");
  }
});
export const fetchQuickTranslateLanguageList = createAsyncThunk<any, void, { state: RootState }>("engageTranslation/fetchQuickTranslateLanguageList", async (args, { getState, dispatch }) => {
  try {
    const response_source_language_list = await get("/common/languages/pick-list", "engage-translate");
    const sourceLanguageList = response_source_language_list.data.map((language: any) => ({
      label: language.name,
      value: language.id,
      id: language.id,
    }));

    return { sourceLanguageList: sourceLanguageList };
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch languages");
  }
});

export const fetchDocumentMetaData = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/documentMetaData", async (args, { getState, dispatch }) => {
  try {
    const response = await get(`/production/documents/${args.documentId}/translated-docs/${args.docId}/metadata`, "engage-translate");
    return response.data;
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});

export const fetchEditDocumentMetaData = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/fetchEditDocumentMetaData", async (args, { getState, dispatch }) => {
  console.log(args);
  try {
    const response = await get(`/production/documents/${args.selectedDocumentID}/translated-docs/${args.selectedID}/metadata`, "engage-translate");
    const response_client_list = await get("/production/clients/pick-list", "engage-translate");
    const response_source_language_list = await get("/common/languages/pick-list", "engage-translate");
    const response_target_language_list = await get(`/common/languages/${response.data.sourceLanguageId}/targets`, "engage-translate");
    const clientList = await response_client_list.data.map((client: any) => ({
      label: client.name,
      value: client.id,
      id: client.id,
    }));
    const sourceLanguageList = await response_source_language_list.data.map((language: any) => ({
      label: language.name,
      value: language.id,
      id: language.id,
    }));
    const targetLanguageList = await response_target_language_list.data.map((language: any) => ({
      label: language.name,
      value: language.id,
      id: language.id,
    }));

    return {
      fetchEditDocumentMetaData: { ...response.data },
      clientList: clientList,
      sourceLanguageList: sourceLanguageList,
      targetLanguageList: targetLanguageList,
    };
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch edit document metadata");
  }
});

export const updateDocumentMetaData = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/updateDocumentMetaData", async (args, { getState, dispatch }) => {
  try {
    const clientName = getState().engageTranslationState.engageTranslateMainState.uploadFormMetaDataState.clientList.find((e) => e.id === args.clientId)?.label;
    const sourceLanguageName = getState().engageTranslationState.engageTranslateMainState.uploadFormMetaDataState.sourceLanguageList.find((e) => e.id === args.sourceLanguageId)?.label;
    const targetLanguageName = getState().engageTranslationState.engageTranslateMainState.uploadFormMetaDataState.targetLanguageList.find((e) => e.id === args.targetLanguageId)?.label;
    const response = await post(
      `/production/documents/metadata`,
      "engage-translate",
      {
        ...args,
        clientName: clientName,
        sourceLanguageName: sourceLanguageName,
        targetLanguageName: targetLanguageName,
      }
      // uploadedBy: "",
    );
    openNotification("Edit Document", "Document updated successfully", response.data);

    dispatch(fetchDocuments({ view: "new" }));
    return response.data;
  } catch (err: any) {
    openNotification("Edit Document", "Failed to save edit document");

    throw new Error(err.response?.data ?? "Failed to update document meta data");
  }
});

export const startTranslation = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/startTranslation", async (args, { getState, dispatch }) => {
  try {
    const response = await post(`/production/documents/${args.selectedDocumentID}/translated-docs/${args.selectedID}/start-translate`, "engage-translate", {});
    const metadata = await get(`/production/documents/${args.selectedDocumentID}/translated-docs/${args.selectedID}/metadata`, "engage-translate");
    dispatch(fetchDocuments({ view: "new" }));
    openNotification("Start Translation", "Translation of the document is starting", metadata.data);
    return response.data;
  } catch (err: any) {
    openNotification("Start Translation", "Failed to start translation");
    throw new Error(err.response?.data ?? "Failed to start translation");
  }
});

export const stopTranslation = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/stopTranslation", async (args, { getState, dispatch }) => {
  try {
    const response = await post(`/common/documents/${args.selectedDocumentID}/translated-docs/${args.selectedID}/stop-translate`, "engage-translate", {});
    const metadata = await get(`/production/documents/${args.selectedDocumentID}/translated-docs/${args.selectedID}/metadata`, "engage-translate");
    dispatch(fetchDocuments({ view: "new" }));
    openNotification("Stop Translation", "Translation of the document is stopping", metadata.data);
    return response.data;
  } catch (err: any) {
    openNotification("Stop Translation", `Failed to stop translation. ${err.response?.message}`);
    throw new Error(err.response?.data ?? "Failed to stop translation");
  }
});

export const deleteDocument = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/deleteDocument", async (args, { getState, dispatch }) => {
  try {
    const metadata = await get(`/common/documents/${args.selectedDocumentID}/translated-docs/${args.selectedID}`, "engage-translate");
    const response = await del(`/common/documents/${args.selectedDocumentID}/translated-docs/${args.selectedID}`, "engage-translate");
    dispatch(fetchDocuments({ view: "new" }));
    console.log("deleted");
    openNotification("Delete Document", "Document deleted successfully", metadata.data);
    return response.data;
  } catch (err: any) {
    openNotification("Delete Document", "Failed to delete document");
    throw new Error(err.response?.data ?? "Failed to delete document");
  }
});
export const updateUploadProgress = createAction<{
  progress: number;
  fileName: string;
}>("engageTranslation/updateUploadProgress");
export const updateUploadCancelToken = createAction<{
  cancelToken: CancelTokenSource;
  fileName: string;
}>("engageTranslation/updateUploadCancelToken");

export const documentUpload = createAsyncThunk<any, DocumentUploadArgs, { state: RootState }>("engageTranslation/documentUpload", async (documentUpload, { dispatch, getState }) => {
  console.log("DOC UPLOAD", documentUpload);
  const userData = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("userData"))));
  const file = documentUpload.file.originFileObj as RcFile;
  const documentReqBody = {
    name: documentUpload.file.name,
    fileName: documentUpload.file.name,
    description: documentUpload.description,
    clientId: documentUpload.clientId,
    sourceLanguageId: documentUpload.sourceLanguageId,
    targetLanguageIds: documentUpload.targetLanguageIds,
    engageProductionId: documentUpload.engageProductionId,
    uploadedBy: userData.idToken.payload.email,
  };

  //calling dispatch to update documentUpload state
  const setCancelToken = (cancelToken: CancelTokenSource) => {
    dispatch(
      updateUploadCancelToken({
        cancelToken: cancelToken,
        fileName: documentReqBody.fileName,
      })
    );
  };
  const onUploadProgress = (progress: number) => {
    dispatch(updateUploadProgress({ progress: progress, fileName: documentReqBody.fileName }));
  };

  // const { file: FileUpload, ...documentUploadReqBody } = {
  //   ...documentUpload,
  //   fileName: fileName,
  //   engageProductionId: documentUpload.engageProductionId || "",
  //   clientName: clientName,
  //   sourceLanguageName: sourceLanguageName,
  //   targetLanguageName: targetLanguageNames,
  // };

  try {
    const response = await putPresigned("/production/documents/upload", "engage-translate", { ...documentReqBody });
    await put(response.data.presignedUrl, file, onUploadProgress, setCancelToken);
    dispatch(fetchDocuments({ view: "new" }));
    return response.data;
  } catch (err: any) {
    console.log(err);
    throw new Error("Failed to upload file");
  }
});

export const searchDocuments = createAsyncThunk<any, { view: string; searchKeyword: string }, { state: RootState }>("engageTranslation/searchDocuments", async (args, { getState, dispatch }) => {
  dispatch(resetTabState(args.view));
  dispatch(
    updateRequestBody({
      requestBody: {
        ...getState().engageTranslationState.newTabState.currentRequestBody,
        keyword: args.searchKeyword,
      },
      view: args.view,
    })
  );
  dispatch(fetchDocuments({ view: args.view }));
});

export const fetchViewDocumentDetailsPresigned = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/fetchViewDocumentDetailsPresigned", async (args, { getState, dispatch }) => {
  try {
    const response = await get(`/common/documents/${args.selectedRecordID}`, "engage-translate");

    console.log(response);

    if (response.data.fileFormat === "docx") {
      const fileResponseInput = await fetch(response.data.inputPathPresignedUrl);
      const sfdtInput = await fileResponseInput.json();
      const fileResponseOutput = await fetch(response.data.outputPathPresignedUrl);
      const sfdtOutput = await fileResponseOutput.json();
      return { ...response.data, sfdtInput: sfdtInput, sfdtOutput: sfdtOutput };
    } else {
      return { ...response.data };
    }
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});

export const fetchDocumentDetailsPresigned = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/fetchDocumentDetailsPresigned", async (args, { getState, dispatch }) => {
  let documentDetail;

  await post(`/production/documents/${args.documentId}/translated-docs/${args.docId}/lock`, "engage-translate", {}).catch((err) => {
    console.log("error locking document");
  });
  try {
    console.log(args);
    const response = await get(`/common/documents/${args.documentId}/translated-docs/${args.docId}`, "engage-translate");

    const status_dropdown_res = await get(`/production/documents/${args.documentId}/translated-docs/${args.docId}/allowed-statuses`, "engage-translate");
    const statusDropdown = status_dropdown_res.data.map((status: any) => ({
      label: status.name,
      value: status.id,
      id: status.id,
    }));
    if (response.data.fileFormat === "docx") {
      const fileResponseInput = await fetch(response.data.inputPathPresignedUrl);
      const sfdtInput = await fileResponseInput.json();
      const fileResponseOutput = await fetch(response.data.outputPathPresignedUrl);
      const sfdtOutput = await fileResponseOutput.json();
      documentDetail = { ...response.data, sfdtInput: sfdtInput, sfdtOutput: sfdtOutput };
    } else {
      documentDetail = { ...response.data };
    }
    // const { inputPathPresignedUrl, outputPathPresignedUrl, inputPath, outputPath, ...documentDetail } = response.data;
    return { documentDetail: documentDetail, statusDropdown: statusDropdown };
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});
// export const fetchDocumentDetailsPresigned = createAsyncThunk<
//   any,
//   number,
//   { state: RootState }
// >(
//   "engageTranslation/fetchDocumentDetailsPresigned",
//   async (selectedRecordID, { getState, dispatch }) => {
//     try {
//       const response = await get(
//         `/documents/${selectedRecordID}`,
//         "engage-translate"
//       );
//       await post(`/documents/${selectedRecordID}/lock`, "engage-translate", {
//         documentId: selectedRecordID,
//         comment: "Started hence lock document",
//       });
//       const {
//         inputPathPresignedUrl,
//         outputPathPresignedUrl,
//         inputPath,
//         outputPath,
//         ...documentDetail
//       } = response.data;
//       return response.data;
//     } catch (err: any) {
//       throw new Error(err.response?.data ?? "Failed to fetch file");
//     }
//   }
// );

export const saveEditDocument = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/saveEditDocument", async (args, { getState, dispatch }) => {
  try {
    const response = await post(`/production/documents/${args.documentId}/translated-docs/${args.docId}/initiate-save-changes`, "engage-translate", {});
    await save(response.data, args.file);
    openNotification("Edit Document", "Document saved successfully");
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to save edit document");
  }
});

export const fetchStatusDropdown = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/fetchStatusDropdown", async (args, { getState, dispatch }) => {
  try {
    const response = await get(`/production/documents/${args.documentId}/translated-docs/${args.docId}/allowed-statuses`, "engage-translate");
    const statusDropdown = response.data.map((status: any) => ({
      label: status,
      value: status,
      id: status,
    }));
    return statusDropdown;
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch status dropdown");
  }
});
export const statusChange = createAsyncThunk<
  any,
  {
    reqEndpoint: string;
    documentId: number;
    docId: number;
    comments: string;
  },
  { state: RootState }
>("engageTranslation/statusChange", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqEndpoint = args.reqEndpoint;
    const reqBody = {
      documentId: args.documentId,
      translatedDocId: args.docId,
      comments: args.comments,
    };
    const response = await post(`/production/documents/${args.documentId}/translated-docs/${args.docId}/${reqEndpoint}`, "engage-translate", reqBody);
    return response;
  } catch (error: any) {
    // console.log("error: ", error.response);
    // rejectWithValue(error.response.data);
    throw new Error(error.response.data.message);
  }
});

export const getDocumentPresigned = createAsyncThunk<any, { selectedDocumentID: number; selectedRecordID: number; action: "download" | "view" }, { state: RootState }>("engageTranslation/getDocumentPresigned", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await get(`/common/documents/${args.selectedDocumentID}/translated-docs/${args.selectedRecordID}/download-urls`, "engage-translate");
    // let responseData;
    // const response = await get(`/documents/${args.selectedRecordID}/download-urls`, "engage-translate");

    // //create a link and download click without getting the user to other page
    // if (args.action === "download") {
    //   const link = document.createElement("a");
    //   link.href = response.data.targetDocPresignedUrl;
    //   link.download = "download.pdf";
    //   link.target = "_blank";
    //   document.body.appendChild(link);
    //   link.click();
    //   link.remove();
    // } else {
    //   if (response.data.fileFormat === "docx") {
    //     const fileResponseOutput = await fetch(response.data.outputPathPresignedUrl);
    //     const sfdtOutput = await fileResponseOutput.json();
    //     responseData = { ...response.data, targetDocPresignedUrl: sfdtOutput };
    //   }
    //   responseData = { ...response.data };
    // }
    //create a link and download click without getting the user to other page
    if (args.action === "download") {
      const link = document.createElement("a");
      link.href = response.data.targetDocPresignedUrl;
      link.download = "download.pdf";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response.data);
  }
});

export const setSelectedDocumentIds = createAction<{
  selectedDocumentIds: React.Key[];
}>("engageTranslation/setSelectedDocumentIds");

export const multiDownloadDocuments = createAsyncThunk<any, void, { state: RootState }>("engageTranslation/multiDownloadDocuments", async (args, { getState, dispatch, rejectWithValue }) => {
  const docIds = getState().engageTranslationState.clientReadyState.selectedDocumentIds;

  if (docIds.length === 0) {
    openNotification("No document(s) selected", "Please select one or more documents to download");
    return rejectWithValue("No document(s) selected");
  }

  if (docIds.length === 1) {
    openNotification("Please select more documents", "Select more than 1 document or download the document individually");
  }

  if (docIds.length > 1) {
    try {
      const response = await post(`/production/documents/multi-downloads`, "engage-translate", {
        translatedDocIds: getState().engageTranslationState.clientReadyState.selectedDocumentIds,
      });
      //create a link and download click without getting the user to other page
      const link = document.createElement("a");
      link.href = response.data.presignedUrl;
      link.download = "";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      // link.remove();
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  }
});

export const getDocumentInfo = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/getDocumentInfo", async (args) => {
  try {
    const response = await get(`/common/documents/${args.documentID}/translated-docs/${args.ID}`, "engage-translate");
    const data = response.data;

    console.log(data);
    // const response_target_language_list = await get(`/common/languages/${data.sourceLanguageId}/targets`, "engage-translate");
    // const response_source_language_list = await get("/common/languages/pick-list", "engage-translate");
    // const response_client_list = await get("/production/clients/pick-list", "engage-translate");

    // const clientName = response_client_list.data.filter((item: any) => {
    //   return item.id === data.clientId;
    // });

    // const sourceLanguage = response_source_language_list.data.filter((item: any) => {
    //   return item.id === data.sourceLanguageId;
    // });

    // data["clientName"] = clientName[0].name;
    // data["sourceLanguageName"] = sourceLanguage[0].name;
    // data["targetLanguageName"] = response_target_language_list.data[0].name;

    return data;
  } catch (err: any) {
    throw new Error("Failed to get document information");
  }
});

export const rearchiveDocument = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/rearchive", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await post(`/production/documents/${args.documentId}/translated-docs/${args.docId}/rearchive`, "engage-translate", {});
    dispatch(fetchDocuments({ view: "archived" }));
    openNotification("Reinstate Document", "Document reinstated successfully");
    return response.data;
  } catch (err: any) {
    openNotification("Reinstate Document", "Failed to reinstate document");
    throw new Error(err.response?.data ?? "Failed to reinstate document");
  }
});

export const fetchSearchTabs = createAsyncThunk<any, void, { state: RootState }>("engageTranslation/fetchSearchTabs", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await get("/production/ui/search-tabs", "engage-translate");
    return response.data;
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch tabs");
  }
});
export const fetchRefresh = createAsyncThunk<any, { view: string }, { state: RootState }>("engageTranslation/fetchRefresh", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    let reqBody;
    switch (args.view) {
      case "new":
        const currentDataLengthNew = getState().engageTranslationState.newTabState.data.length === 0 ? 30 : getState().engageTranslationState.newTabState.data.length;
        reqBody = {
          ...getState().engageTranslationState.newTabState.currentRequestBody,
          pageSize: Math.ceil(currentDataLengthNew / 30) * 30,
          page: 1,
          viewName: "new",
        };

        // reqBody = { ...getState().engageTranslationState.newTabState.currentRequestBody, pageSize: getState().engageTranslationState.newTabState.pagination.page * getState().engageTranslationState.newTabState.pagination.pageSize };
        break;
      case "quality-control":
        const currentDataLengthQA = getState().engageTranslationState.qualityControlState.data.length === 0 ? 30 : getState().engageTranslationState.qualityControlState.data.length;
        reqBody = {
          ...getState().engageTranslationState.qualityControlState.currentRequestBody,
          pageSize: Math.ceil(currentDataLengthQA / 30) * 30,
          page: 1,
          viewName: "quality-control",
        };
        // reqBody = { ...getState().engageTranslationState.qualityControlState.currentRequestBody, pageSize: getState().engageTranslationState.qualityControlState.pagination.page * getState().engageTranslationState.qualityControlState.pagination.pageSize };
        break;
      case "client-ready":
        const currentDataLengthCR = getState().engageTranslationState.clientReadyState.data.length === 0 ? 30 : getState().engageTranslationState.clientReadyState.data.length;
        reqBody = {
          ...getState().engageTranslationState.clientReadyState.currentRequestBody,
          pageSize: Math.ceil(currentDataLengthCR / 30) * 30,
          page: 1,
          viewName: "client-ready",
        };
        // reqBody = { ...getState().engageTranslationState.clientReadyState.currentRequestBody };
        // reqBody = { ...getState().engageTranslationState.clientReadyState.currentRequestBody, pageSize: getState().engageTranslationState.clientReadyState.pagination.page * getState().engageTranslationState.clientReadyState.pagination.pageSize };
        break;
      case "archived":
        const currentDataLengthArchived = getState().engageTranslationState.archivedTabState.data.length === 0 ? 30 : getState().engageTranslationState.archivedTabState.data.length;
        reqBody = {
          ...getState().engageTranslationState.archivedTabState.currentRequestBody,
          pageSize: Math.ceil(currentDataLengthArchived / 30) * 30,
          page: 1,
          viewName: "archived",
        };
        // reqBody = { ...getState().engageTranslationState.archivedTabState.currentRequestBody };
        // reqBody = { ...getState().engageTranslationState.archivedTabState.currentRequestBody, pageSize: getState().engageTranslationState.archivedTabState.pagination.page * getState().engageTranslationState.archivedTabState.pagination.pageSize };
        break;
      case "all":
        const currentDataLengthAll = getState().engageTranslationState.allTabState.data.length === 0 ? 30 : getState().engageTranslationState.allTabState.data.length;
        reqBody = {
          ...getState().engageTranslationState.allTabState.currentRequestBody,
          pageSize: Math.ceil(currentDataLengthAll / 30) * 30,
          page: 1,
          viewName: "all",
        };
        break;
      default:
        const currentDataLengthDefault = getState().engageTranslationState.newTabState.data.length === 0 ? 30 : getState().engageTranslationState.newTabState.data.length;
        reqBody = {
          ...getState().engageTranslationState.newTabState.currentRequestBody,
          pageSize: Math.ceil(currentDataLengthDefault / 30) * 30,
          page: 1,
          viewName: "new",
        };
        // reqBody = { ...getState().engageTranslationState.newTabState.currentRequestBody };
        // reqBody = { ...getState().engageTranslationState.newTabState.currentRequestBody, pageSize: getState().engageTranslationState.newTabState.pagination.page * getState().engageTranslationState.newTabState.pagination.pageSize };
        break;
    }

    const response = await post("/production/documents/search", "engage-translate", reqBody);
    const tabViews = response.data.tabViews.map((tabView: any) => {
      return {
        label: tabView.name,
        key: tabView.internalName,
        count: tabView.count,
      };
    });

    return { ...response.data, view: args.view, tabViews: tabViews };
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});
//in 15 seconds interval
export const autoRefresh = createAsyncThunk<any, { view: string }, { state: RootState }>("engageTranslation/autoRefresh", async (args, { getState, dispatch, rejectWithValue }) => {
  if (getState().engageTranslationState.autoRefreshState.currentIntervalId) {
    clearInterval(getState().engageTranslationState.autoRefreshState.currentIntervalId);
  }
  if (getState().engageTranslationState.autoRefreshState.autoRefresh) {
    const intervalId = setInterval(() => {
      // Your auto-refresh logic here
      dispatch(fetchRefresh({ view: args.view }));

      // Increment the counter to trigger a re-render
    }, 5000); // 15 seconds interval
    dispatch(setAutoRefresh({ view: args.view, intervalId: intervalId }));
  }
});

export const transferToQC = createAsyncThunk<any, any, { state: RootState }>("engageTranslation/transferToQC", async (args, { getState, dispatch }) => {
  try {
    const response = await post(`/documents/${args.documentId}/qctransfer`, "engage-translate", { documentId: args.documentId, comments: args.comments });
    console.log(response);
    return response.data;
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to transfer to QC");
  }
});

export const setAutoRefresh = createAction<{ view: string; intervalId: NodeJS.Timer }>("engageTranslation/setAutoRefresh");
export const stopAutoRefresh = createAction("engageTranslation/stopAutoRefresh");
export const switchAutoFresh = createAction<{ autoRefresh: boolean }>("engageTranslation/switchAutoFresh");
export const setSelectedRecord = createAction<{
  view: string;
  selectedRecordID: number;
  selectedDocumentID?: number;
}>("engageTranslation/setSelectedRecord");
export const storeDocumentInfo = createAction<{
  selectedRecordName: string;
  selectedRecordID: number;
  selectedDocumentID?: number;
}>("engageTranslation/storeDocumentInfo");
export const resetSelectedDocument = createAction<{ view: string }>("engageTranslation/resetSelectedDocument");
export const resetRequestBody = createAction("engageTranslation/resetRequestBody");
export const resetTabState = createAction<string>("engageTranslation/resetTabState");
export const updateRequestBody = createAction<{
  requestBody: defaultRequestBodyType;
  view: string;
}>("engageTranslation/updateRequestBody");
export const updateTab = createAction<string>("engageTranslation/updateTab");
export const resetUpdateStatusState = createAction("engageTranslation/resetUpdateStatusState");
export const openEditTranslationDocument = createAction("engageTranslation/openEditTranslationDocument");
export const closeEditTranslationDocument = createAction("engageTranslation/closeEditTranslationDocument");
export const openDeleteTranslationDocument = createAction("engageTranslation/openDeleteTranslationDocument");
export const closeDeleteTranslationDocument = createAction("engageTranslation/closeDeleteTranslationDocument");
export const openUploadTranslationDocument = createAction("engageTranslation/openUploadTranslationDocument");
export const openQuickUploadTranslationDocument = createAction("engageTranslation/openQuickUploadTranslationDocument");
export const closeUploadTranslationDocument = createAction("engageTranslation/closeUploadTranslationDocument");
export const closeQuickUploadTranslationDocument = createAction("engageTranslation/closeQuickUploadTranslationDocument");
export const openUploadFileProgress = createAction("engageTranslation/openUploadFileProgress");
export const closeUploadFileProgress = createAction("engageTranslation/closeUploadFileProgress");
export const openDocumentInformation = createAction("engageTranslation/openDocumentInformation");
export const closeDocumentInformation = createAction("engageTranslation/closeDocumentInformation");
export const openViewDocument = createAction("engageTranslation/openViewDocument");
export const closeViewDocument = createAction("engageTranslation/closeViewDocument");
export const openDocumentInfoModal = createAction("engageTranslation/openDocumentInfoModal");
export const closeDocumentInfoModal = createAction("engageTranslation/closeDocumentInfoModal");
export const auditLogModalOpen = createAction("engageTranslation/auditLogModalOpen");
export const auditLogModalClose = createAction("engageTranslation/auditLogModalClose");
export const auditLogModalData = createAction<{ data: any }>("engageTranslation/auditLogModalData");
export const openLogoutModal = createAction("engageTranslation/openLogoutModal");
export const closeLogoutModal = createAction("engageTranslation/closeLogoutModal");
export const setCustomFont = createAction<any>("engageTranslation/setCustomFont");
